import { render, staticRenderFns } from "./CarInsuranceList.vue?vue&type=template&id=02ecfbd9&scoped=true&"
import script from "./CarInsuranceList.vue?vue&type=script&lang=js&"
export * from "./CarInsuranceList.vue?vue&type=script&lang=js&"
import style0 from "./CarInsuranceList.vue?vue&type=style&index=0&id=02ecfbd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ecfbd9",
  null
  
)

export default component.exports